import * as amplitude from "@amplitude/analytics-browser";

import { getAptConfig, isProd } from "client/config";
import { Merchant } from "client/lib/apt-merchant/src/merchant";
import { isRunningJest } from "client/utils";

import { getMerchantPropertiesForAmplitude } from "./utils";

const amplitudeKey = getAptConfig("AMPLITUDE_KEY");

let _amplitudeEventProperties: DynamicProps = {};

type DynamicProps = {
  [key: string]: string;
};

export const initializeAmplitude = (
  userProperties: DynamicProps = {}
): void => {
  amplitude.init(amplitudeKey, undefined, {
    defaultTracking: true,
  });

  if (userProperties) {
    setAmplitudeUserProperties(userProperties);
  }
};

export function logAmplitudeEvent(
  eventName: string,
  eventType: string,
  eventStats: Record<string, string | boolean | number> = {}
): void {
  const merchantProps = getMerchantPropertiesForAmplitude(
    Merchant.getInstance()
  );
  const { pathname, search } = window.location;
  if (isProd) {
    // explicitly destructure pathname, search, and type to avoid being overridden by eventStats
    const {
      pathname: _,
      search: __,
      type: ___,
      ...restEventStats
    } = eventStats;
    amplitude.track(eventName, {
      type: eventType,
      pathname,
      search,
      ...restEventStats,
      ...amplitudeEventProperties.get(),
      ...merchantProps,
    });
  } else {
    if (!isRunningJest()) {
      // don't run this in jest workers
      console.log(
        `%c[AMPLITUDE] ${eventName}`,
        "color: #0099ff; font-weight: bold;",
        {
          type: eventType,
          ...eventStats,
          ...amplitudeEventProperties.get(),
          ...merchantProps,
          pathname,
          searchUrlParams: search,
        }
      );
    }
  }
}

export function setAmplitudeUserId(id: string): void {
  if (isProd) {
    amplitude.setUserId(id);
  }
}
export const amplitudeEventProperties = {
  get: (): DynamicProps => _amplitudeEventProperties,
  set: (props: DynamicProps = {}): void => {
    _amplitudeEventProperties = props;
  },
};

export function setAmplitudeUserProperties(userProperties: {
  [key: string]: string;
}): void {
  if (isProd) {
    const identify = new amplitude.Identify();
    Object.keys(userProperties).forEach((key) => {
      identify.set(key, userProperties[key]);
    });
    amplitude.identify(identify);
  } else {
    if (!isRunningJest()) {
      console.log(
        `%c[AMPLITUDE] set user properties`,
        "color: #0099ff; font-weight: bold;",
        JSON.stringify(userProperties, null, 4)
      );
    }
  }
}

export function setAmplitudeDeviceId(deviceId: string): void {
  if (isProd) {
    amplitude.setDeviceId(deviceId);
  } else {
    if (!isRunningJest()) {
      console.log(
        `%c[AMPLITUDE] set device id`,
        "color: #0099ff; font-weight: bold;",
        deviceId
      );
    }
  }
}
